import { useAppDispatch, useAppSelector } from 'hooks'
import useAuth from 'hooks/useAuth'
import { useMemo } from 'react'
import {
 TChatListData,
 TChatScreen,
 TChatState,
 TGetChatMessage,
} from '../types/index'
import {
 clearChatList,
 removeFromChatList,
 resetChatState,
 setReplyMsg,
 showChatModal,
 toggleChat,
 toggleHeaderCollps,
 toggleMinimize,
 toggleModalInvite,
 updateChatList,
 updateChatListById,
} from '../reducer/ChatSlice'

type TUseChatNewResp = {
 state: TChatState
 showChatModal?: (val: boolean) => void
 updateChatList?: (val: TChatListData) => void
 removeFromChatList?: (v: { id: any }) => void
 clearChatList?: () => void
 toggleChat?: () => void
 updateState?: (p: TChatState) => void
 toggleHeader?: () => void
 toggleInviteModal?: (p: boolean) => void
 setReply?: (v: TGetChatMessage | null) => void
 isGroupAdmin?: boolean
 resetChatState?: () => void
 toggleMinimize?: () => void
 updateChatListById?: (p: { id: any; data: Partial<TChatListData> }) => void
 addGroupChat?: (val: TChatListData) => void
}

const useChat = (): TUseChatNewResp => {
 const { user } = useAuth()
 const dispatch = useAppDispatch()
 const state = useAppSelector((state) => state.chat)
 return {
  state,
  showChatModal: (v) => dispatch(showChatModal(v)),
  clearChatList: () => dispatch(clearChatList()),
  updateChatList: (val) => dispatch(updateChatList(val)),
  removeFromChatList: (val) => dispatch(removeFromChatList(val)),
  toggleChat: () => dispatch(toggleChat()),
  toggleHeader: () => dispatch(toggleHeaderCollps()),
  toggleInviteModal: (p) => dispatch(toggleModalInvite(p)),
  setReply: (p) => dispatch(setReplyMsg(p)),
  resetChatState: () => dispatch(resetChatState()),
  toggleMinimize: () => dispatch(toggleMinimize()),
  updateChatListById: (p) => dispatch(updateChatListById(p)),
  isGroupAdmin: useMemo(() => {
   if (user?.id && state.activeGroupAdmin) {
    return user?.id === state.activeGroupAdmin
   }
   return false
  }, [state.activeGroupAdmin, user?.id]),
 }
}

export default useChat
